import { StrictMode, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { createGlobalStyle } from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"
import * as Sentry from "@sentry/react"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { I18n } from "src/domains/i18n/i18n"
import { routeTree } from "src/routeTree.gen"
import { NotFound404 } from "src/ui/not-found-404/not-found-404"

Sentry.init({
  dsn: "https://b25e7674a0e0fb1f5009f51c09eef2b2@o332226.ingest.us.sentry.io/4511547330789376",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.7,
  tracePropagationTargets: [/^https?:\/\/([a-zA-Z0-9-]+\.)*minut\.com(\/|$)/], // Only attach traces to minut.com domains
})

const rootElement = document.getElementById("root")

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFound404,
})

if (!rootElement) {
  throw new Error("Root element not found")
}

createRoot(rootElement).render(<Main />)

function Main() {
  return (
    <StrictMode>
      <I18n>
        <GlobalStyle />
        <Suspense fallback={null}>
          <RouterProvider router={router} />
        </Suspense>
      </I18n>
    </StrictMode>
  )
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Figtree', sans-serif;
    -webkit-font-smoothing: antialiased; /* Chrome, Safari */
    -moz-osx-font-smoothing: grayscale;
    color: ${colors.textPrimary};
  }

  button {
    font-family: inherit;
  }

  textarea {
    font-family: inherit;
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`
